var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8402 4.36563C10.0313 3.57786 8.95171 3.14869 7.83472 3.16633C5.79076 3.16633 4.05484 4.57432 3.43588 6.47025C3.10769 7.46379 3.10769 8.53967 3.43588 9.5332H3.43875C4.06058 11.4262 5.79363 12.8342 7.8376 12.8342C8.8927 12.8342 9.7985 12.5587 10.5005 12.0719V12.07C11.3268 11.5115 11.891 10.6326 12.0666 9.63904H7.83473V6.55849H15.2247C15.3168 7.09347 15.36 7.64021 15.36 8.18401C15.36 10.6172 14.5084 12.6743 13.0266 14.0676L13.0281 14.0688C11.7298 15.2916 9.94778 16 7.83472 16C4.87241 16 2.16343 14.2951 0.833412 11.5938C-0.277807 9.33332 -0.277804 6.67018 0.83342 4.40974C2.16344 1.70544 4.87241 0.000539092 7.83472 0.000539092C9.78081 -0.0229765 11.6607 0.723645 13.0771 2.08167L10.8402 4.36563Z",
    fill: "#4D2481"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.cf8219c044932faee172151a3c290549.svg";
export { ForwardRef as ReactComponent };